<template>
  <div class="preferredBrand-list">
    <div>
      <TopImage :dataSource="dataSource"></TopImage>
      <div class="area">
        <BrandList :brandList="brandList"></BrandList>
      </div>
    </div>
    <LeftMenu :brandList="brandList"></LeftMenu>
    <el-backtop botton="100" class="toTopBtn">
      <div>
        <img src="~@/assets/img/preferredBrand/backTop.png" />
        回到顶部
      </div>
    </el-backtop>
  </div>
</template>

<script>
import TopImage from "./components/topImage.vue";
import LeftMenu from "./components/leftMenu.vue";
import BrandList from "./components/brandList.vue";
export default {
  components: {
    TopImage,
    LeftMenu,
    BrandList,
  },
  data() {
    return {
      brandList: [],
      dataSource: {
        imageUrl: "",
        videoUrl: "",
      },
    };
  },
  mounted() {
    this.getList();
    this.getPageSet();
  },
  methods: {
    getList() {
      this.$http
        .post(`/front/cross/commodity-user/brand/premiumCategoryBrandList`, {})
        .then(({ data: res }) => {
          if (res.code === 0) {
            console.log(res.data);

            this.brandList = res.data.dataList || [];
          }
        });
    },
    getPageSet() {
      this.$http
        .get(`/front/cross/commodity-user/brand/getPremiumHomeConfig`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            console.log(res.data);
            const { imageUrl, videoUrl } = res.data;
            this.dataSource = {
              imageUrl,
              videoUrl,
            };
          }
        });
    },
  },
  beforeDestroy() {
    window.onreset = () => {};
  },
  beforeCreate() {
    console.log("beforeCreate");
    window.onresize = jumpLink;
    jumpLink();
    function jumpLink() {
      const w = window.screen.width;
      const minWidth = 900;
      if (w < minWidth) {
        const host = window.location.host;

        if (host.includes("10.10.56") || host.includes("localhost")) {
          window.location.href =
            window.location.protocol +
            "//" +
            window.location.hostname +
            ":5000/#/pages/preferredBrand/list"
        } else if (host.includes("predev")) {
          window.location.href =
            "http://predevm.plantmate.supcon.com:8888/#/pages/preferredBrand/list"
        } else if (host.includes("pretest")) {
          window.location.href =
            "http://pretestm.plantmate.supcon.com:8888/#/pages/preferredBrand/list"
        } else if (host.includes("uat2")) {
          window.location.href =
            "https://uat2m-plantmate.supcon.com:8888/#/pages/preferredBrand/list"
        } else {
          window.location.href =
            "https://m.plantmate.com/#/pages/preferredBrand/list"
        }
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.preferredBrand-list {
  background: #2a54d1;
  font-family: Alibaba PuHuiTi;
  min-width: 1240px;
  .area {
    padding-top: 10px;
    width: 1200px;
    margin: 0 auto;
  }
  .toTopBtn {
    width: 64px;
    height: 64px;
    border-radius: 16px;
    background: #ffffff;
    font-size: 12px;
    text-align: center;
    color: #666666;
    padding: 8px 20px;
    box-sizing: border-box;
    z-index: 99999;
  }
}
</style>
